/**
 * 微信方法
 * */

import {getUrlParamsTools} from "./tools";
import { getWxSharService } from '../service/weChatService';
import wx from 'weixin-js-sdk';
/**
 * 获取微信授权信息
 * @param cb
 */
export const getWechatInfo = cb => {
    const code = getUrlParamsTools('code'),
        appId = 'wxb4b764389354b3ce',
        url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + encodeURIComponent(location.href) + "&response_type=code&scope=snsapi_userinfo&state=STATE";
    if(!code){
        window.location = url;
    }else{
        cb(code);
    }
};



export const weChatPay = () => {

};

/**
 * 微信分享
 */
export const wecharShare = (href,route) => {
	console.log("wecharShare-href",href);
	console.log("wecharShare-route",route);
	var link = href+'#/'+route;
	console.log("wecharShare-link",link);
	const that = this;
	getWxSharService(encodeURIComponent(href)).then(result => {
		if (result.status === 1) {
			wx.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: result.datas.appId, // 公众号名称，由商户传入
				timestamp: result.datas.timestamp, // 时间戳，自1970年以来的秒数
				nonceStr: result.datas.nonceStr, // 随机串
				signature: result.datas.signature, // 微信签名
				jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
			});
			wx.ready(function() {
				//分享到朋友圈
				wx.updateTimelineShareData({
					title: '收到乐', // 分享标题
					link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: 'https://www.shoudaole.cn/uploads/default/logo.png', // 分享图标
					success: function() {
						// Toast('分享成功');
					}
				});
				//分享给朋友
				wx.updateAppMessageShareData({
					title: '收到乐', // 分享标题
					desc: '收到乐页面分享', //分享描述
					link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: 'https://www.shoudaole.cn/uploads/default/logo.png', // 分享图标
					success: function() {
						// Toast('分享成功');
					}
				});
			});
		} else {
			Toast(result.msg);
		}
	});
}